/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Insights_Lpvisibility_Showall3Inputs */

const en_coinvestments_insights_lpvisibility_showall3 = /** @type {(inputs: Coinvestments_Insights_Lpvisibility_Showall3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show all`)
};

/**
* | output |
* | --- |
* | "Show all" |
*
* @param {Coinvestments_Insights_Lpvisibility_Showall3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_insights_lpvisibility_showall3 = /** @type {((inputs?: Coinvestments_Insights_Lpvisibility_Showall3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Insights_Lpvisibility_Showall3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_insights_lpvisibility_showall3(inputs)
});
export { coinvestments_insights_lpvisibility_showall3 as "coInvestments_insights_lpVisibility_showAll" }